<ng-container *transloco="let t">
    <div class="blue-background"></div>
    <header
        focusonnavigation=""
        aria-label="Get started"
        id="homepage-header"
        class="home-header-background"
        tabindex="-1"
        style="outline: none"
    >
        <div class="home-header-section">
            <div class="home-header-headline">
                <h1>{{ client?.clientName }}</h1>
                <h2>{{ t("program.header.second") }}</h2>
            </div>
        </div>
    </header>
    <div fxLayoutAlign="center center" class="program-box-outer">
        <div class="program-box-inner">
            <app-program-card-collection></app-program-card-collection>
        </div>
    </div>
</ng-container>
